import { ErrorHandlerOptions } from '../interfaces/error-handler-options';

export const errorHandlerOptionsDefaults: ErrorHandlerOptions = {
  appName: 'PORTAL',
  loggerName: 'Portal web',
};
